/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { AlertErrorForm } from '../../../components/AlertErrorForm'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAuth } from '../../../hooks/useAuth'
import { whoIamService } from '../../../services/auth.service'
import { userService } from '../../../services/user.service'
import { schemaUpdateUser } from './schemaDetail'
import { ClabeInterbancaria } from './ClabeInterbancari'
export const AccountDetail = () => {
  const { user } = useAuth()
  const [isUpdated, setIsUpdated] = useState(false)
  const [pendingOnboarding, setPendingOnboarding] = useState(true)
  const [onboardingStarted, setOnboardingStarted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [role, setRole] = useState('')

  const handleEspectadorChange = () => {
    setRole('Espectador')
  }

  const handleOrganizadorChange = () => {
    setRole('Organizador')
  }

  // Hice un use effect aparte para asignar el rol del usuario
  // Para al momento de actualizar el rol en la interfaz no haya conflicto
  useEffect(() => {
    // Esta función se está corriendo 6 veces, sería bueno investigar que causa esto
    const getAccountUser = async () => {
      try {
        const data = await whoIamService(user.token)
        // Asignamos un rol al usuario
        const userRole = data.typeUser.charAt(0).toUpperCase() + data.typeUser.slice(1)
        setRole(userRole)
      } catch (error) {
        console.log(error)
      }
    }
    getAccountUser()
  }, [isUpdated])

  useEffect(() => {
    // Funcion que verifica si el usuario tiene un onboarding de stripe pendiente
    // Si el onboarding está pendiente, el usuario no podrá recibir pagos
    const verifyOrganizerOnboarding = async () => {
      try {
        setIsLoading(true)
        const response = await userService.verifyStripeConnectOnboarding(user.uid)
        console.log(response)
        if (response.onboardingStarted) setOnboardingStarted(true)
        if (!response.onboardingPending) setPendingOnboarding(false)
        setIsLoading(false)
      } catch (error) {
        console.log(error)
        setIsLoading(false)
      }
    }

    if (role === 'Organizador') verifyOrganizerOnboarding()
  }, [role])

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schemaUpdateUser),
    defaultValues: user
  })

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)
      if (role === 'Espectador') {
        await updateUser(data)
      } else if (role === 'Organizador' && !onboardingStarted) {
        await startOrganizerOnboarding(data)
      } else if (role === 'Organizador' && pendingOnboarding && onboardingStarted) {
        await continueOrganizerOnboarding()
      } else if (role === 'Organizador' && !pendingOnboarding && onboardingStarted) {
        await updateUser(data)
      }
      setIsUpdated(!isUpdated)
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }

  const updateUser = async (data) => {
    await userService.updateOneUser((user.uid), {
      nombre: data.nombre,
      email: data.email,
      phoneNumber: data.phoneNumber,
      rol: role
    })
  }

  const startOrganizerOnboarding = async (data) => {
    const response = await userService.startOrganizerOnboarding(user.uid, {
      nombre: data.nombre,
      email: data.email,
      phoneNumber: data.phoneNumber,
      rol: role
    })
    window.location.replace(response.accountLink.url)
  }

  const continueOrganizerOnboarding = async () => {
    const response = await userService.continueOrganizerOnboarding(user.uid)
    window.location.replace(response.accountLink.url)
  }

  const textToDisplay = () => {
    if (isLoading) return '...'
    if (role === 'Espectador') {
      return 'Guardar Cambios'
    } else if (role === 'Organizador' && !onboardingStarted) {
      return 'Comenzar Onboarding'
    } else if (role === 'Organizador' && pendingOnboarding && onboardingStarted) {
      return 'Continuar Onboarding'
    } else if (role === 'Organizador' && !pendingOnboarding && onboardingStarted) {
      return 'Guardar Cambios'
    }
    return 'Continuar'
  }

  return (
    <>
      {/* Account details */}
      <div className="ps-md-3 ps-lg-0 mt-md-2 py-md-4">
        <h1 className="h2 pt-xl-1 pb-3 text-primary">Detalle de cuenta</h1>
        {/* Basic info */}
        <div className="form-check">
          <RadioButton
              label="Espectador"
              value={role === 'Espectador'}
              onChange={handleEspectadorChange}
          />
        </div>
        <div className="form-check">
          <RadioButton
            label="Organizador"
            value={role === 'Organizador'}
            onChange={handleOrganizadorChange}
          />
        </div>
        <h2 className="h5 text-primary mb-4">Información</h2>
        <form className="border-bottom pb-3 pb-lg-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="row pb-2">
            <div className="col-sm-12 mb-4">
              <label htmlFor="nombre" className="form-label fs-base text-white">
                Nombre
              </label>
              <input
                type="text" id="nombre"
                className="form-control form-control-lg"
                { ...register('nombre')}
              />
              <AlertErrorForm messageError={errors.nombre?.message} />
            </div>
            <div className="col-sm-6 mb-4">
              <label htmlFor="email" className="form-label fs-base text-white">Correo electrónico</label>
              <input type="email"
                id="email"
                className="form-control form-control-lg"
                {...register('email')}
              />
              <AlertErrorForm messageError={errors.email?.message} />
            </div>
            <div className="col-sm-6 mb-4">
              <label htmlFor="phone" className="form-label fs-base text-white">Celular</label>
              <input type="text"
                id="phone"
                className="form-control form-control-lg"
                readOnly
                value={user.phoneNumber}
              />
              {/* <AlertErrorForm messageError={errors.celular?.message} /> */}
            </div>
          </div>
          <div className="d-flex mb-3">
            {/* Considerar remover boton reset, no acopla mucho funcionamiento */}
            <button type="reset" disabled={isLoading} className="btn btn-secondary me-3">Cancelar </button>
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary"
            >
              <span id='button-text'>
                {isLoading ? <div className='spinner' id='spinner'></div> : textToDisplay()}
              </span>
            </button>
          </div>
        </form>
        {/* Change clabe interbancaria */}
        {
          user.typeUser !== 'admin' && (<ClabeInterbancaria />)
        }
        {/* Change password account */}
        {/* <div className="form-password mb-4">
          <h2 className="h5 text-primary pt-1 pt-lg-3 mt-4">Seguridad</h2>
          <Link to="cambiar-password" className=' text-left'>Cambiar contraseña</Link>
        </div> */}
      </div>
    </>
  )
}

const RadioButton = ({ label, value, onChange }) => {
  return (
    <label className='form-label fs-base text-white'>
      <input type="radio" className="form-check-input" checked={value} onChange={onChange} />
      {label}
    </label>
  )
}
